exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#INIT{background-color:#000;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden!important}.input-group__details{min-height:5px!important}.input-group__details:after,.input-group__details:before{height:5px!important}.input-group--text-field input,.input-group--text-field textarea{font-size:55px;height:65px;text-align:center}.btnPOS{margin-top:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-099eb99a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Loading.vue
// module id = 676
// module chunks = 0